/**
 * 初始化相关数据
 */

import { reactive } from 'vue';

import { urlUtil, localStorageUtil } from '@/utils';
function initFormData(flag) {
  let { uid, uname, source_url, product_name } = urlUtil.parseQuery();
  source_url = source_url && decodeURIComponent(source_url);
  uname = uname && decodeURIComponent(uname);
  return {
    report_theme: flag ? '1' : undefined,
    informer: flag ? '1' : undefined,
    // type: flag ? undefined : 0, 举报类型
    // department: undefined,
    content: flag ? '1' : undefined,
    file: [],
    area_name: undefined,
    // area_code: undefined,
    contacts: flag ? '1' : undefined,
    mobile: flag ? '18123390165' : undefined,
    email: flag ? 'ycg520520@qq.com' : undefined,
    uid,
    uname,
    source_url,
    product_name,
    // 新增
    // 服务类型（1-3）
    source: undefined,
    // 线索类型（1-8）
    source_type: undefined,
    tel: flag ? '18123390165' : undefined,
    code: flag ? '123456' : undefined
  };
  // return flag
  //   ? {
  //       report_theme: '1',
  //       informer: '1',
  //       type: 1,
  //       // department: 'http://www.baidu.com',
  //       content: '1',
  //       file: [],
  //       area_name: undefined,
  //       // area_code: '420102',
  //       contacts: '1',
  //       mobile: '18123390165',
  //       email: 'ycg520520@qq.com',
  //       uid,
  //       uname,
  //       source_url,
  //       product_name
  //     }
  //   : {
  //       report_theme: undefined,
  //       informer: undefined,
  //       type: 0,
  //       // department: undefined,
  //       content: undefined,
  //       file: [],
  //       area_name: undefined,
  //       // area_code: undefined,
  //       contacts: undefined,
  //       mobile: undefined,
  //       email: undefined,
  //       uid,
  //       uname,
  //       source_url,
  //       product_name
  //     };
}

function initFindFormData(flag) {
  return flag
    ? {
        mobile: 18123390165,
        code: undefined
      }
    : {
        mobile: undefined
      };
}

const active = parseInt(localStorageUtil.get('tabAction') || 0, 10);
const state = reactive({
  value: '',
  showPicker: false,
  imageData: {},
  visible: false,
  active,
  // 提交投诉验证码相关数据
  disabledSubmit: true,
  complainSMS: {
    text: '获取验证码',
    disabled: false,
    primary: 'primary'
  },
  // 提交查询投诉进度验证码相关数据
  disabledFindSubmit: true,
  findSMS: {
    text: '获取验证码',
    disabled: false,
    primary: 'primary'
  },
  isReplyFind: false,
  replyData: [],
  // 新增
  showSourceType: false,
  isAgree: false,
  // source: [
  //   { label: '线索征集', value: 1 },
  //   { label: '报警求助', value: 2 },
  //   { label: '投诉举报', value: 3 }
  // ],
  sourceType: [
    { text: '淫秽色情', value: 1 },
    { text: '网络赌博', value: 2 },
    { text: '网络诈骗', value: 3 },
    { text: '计算机破坏', value: 4 },
    { text: '网络水军', value: 5 },
    { text: '传播散步谣言', value: 6 },
    { text: '暴恐音视频', value: 7 },
    { text: '其他', value: 8 }
  ],
  selectedSourceTypeText: '',
  isVerifyCode: false
});

const formData = reactive(initFormData(process.env.NODE_ENV === 'development'));
const findFormData = reactive(initFindFormData(process.env.NODE_ENV === 'development'));
const urlReg = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([:?#=/\w.-]*)*\/?$/;
const mobileReg = /^([1]\d{10}|([(（]?0[0-9]{2,3}[）)]?[-]?)?([2-9][0-9]{6,7})+(-[0-9]{1,4})?)$/;
function countDownFn(state, count = 60) {
  state.disabled = true;
  state.primary = 'default';
  state.text = `${count}秒后重发`;
  let timer = setInterval(() => {
    count--;
    if (count < 0) {
      count = 60;
      clearInterval(timer);
      state.disabled = false;
      state.text = '重获验证码';
      state.primary = 'primary';
    } else {
      state.text = `${count}秒后重发`;
    }
  }, 1000);
}
export {
  state,
  formData,
  findFormData,
  urlReg,
  mobileReg,
  initFormData,
  initFindFormData,
  countDownFn
};
